<app-navbar>
  <header></header>
  <main style="height: 100%">
    <router-outlet></router-outlet>
  </main>
  <!-- <footer class="mt-2 p-2 text-center">
    <a href="https://alfasu.com">alfasu.com</a>
  </footer> -->
</app-navbar>
